<h3 class="title">
    @if (needMetrics()) {
        Выбор метрики
    } @else {
        Выбор устройства
    }

    @if (canAddDataset() === false) {
        <span class="info-message">
            <i class="pi pi-info-circle"></i>
            Выбрано максимальное количество метрик
        </span>
    }
</h3>

<div class="items">
    @if (element()) {
        @if (needMetrics()) {
            @for (node of selectedMetricsNodes(); track node.id; let index = $index) {
                <p-button severity="secondary"
                          [label]="node.name"
                          size="small"
                          (click)="changeNodesMetricsMenu.toggle($event);
                                  setSelectedMetricsNodeId(selectedMetricsNodes()[index - 1] ? selectedMetricsNodes()[index - 1].id : null);
                                  setDisabledDeviceMetricsNodeId(node.id);
                                  selectedMetricsNodeIndex.set(index)"
                          [disabled]="!element()"/>
            }

            @if (selectedMetric()) {
                <p-button severity="secondary"
                          [label]="selectedMetric()!.name"
                          size="small"
                          styleClass="metric"
                          (click)="changeMetricsMenu.toggle($event);
                                  setSelectedMetricsNodeId(selectedMetricsNodes()[selectedMetricsNodes().length - 1].id);
                                  selectedMetricsNodeIndex.set(selectedMetricsNodes().length)"
                />
            }
        } @else {
            @for (node of selectedDeviceNodes(); track node.id; let index = $index) {
                <p-button severity="secondary"
                          [label]="node.name"
                          size="small"
                          (click)="changeNodesDevicesMenu.toggle($event);
                                    setSelectedDeviceNodeId(selectedDeviceNodes()[index - 1] ? selectedDeviceNodes()[index - 1].id : null);
                                    setDisabledDeviceNodeId(node.id);
                                    selectedDeviceNodeIndex.set(index)"
                          [disabled]="!element()"/>
            }
        }
    }

    @if (needMetrics()) {
        @if (!selectedMetric()) {
            <p-button severity="secondary"
                      icon="pi pi-plus"
                      size="small"
                      (click)="toggleMetricsMenu($event)"
                      [disabled]="!element() || !metricsMenuNodes().length || selectedMetric()"
                      [loading]="fetching()"/>
        } @else {
            <p-button severity="primary"
                      icon="pi pi-check"
                      size="small"
                      (click)="updateEditingElementMetrics()"
                      [disabled]="!element() || !selectedMetric() || selectedElementIncludesSelectedMetric() || !canAddDataset() || settingsLoading()"
                      [loading]="fetching()"/>
        }
    } @else {
        <p-button severity="secondary"
                  icon="pi pi-plus"
                  size="small"
                  (click)="toggleDevicesMenu($event)"
                  [disabled]="!element() || !devicesMenuNodes()[0].items?.length"
                  [loading]="fetching()"/>

        @if (selectedDeviceNodes().length) {
            <p-button severity="primary"
                      icon="pi pi-check"
                      size="small"
                      (click)="updateEditingElementDevices()"
                      [disabled]="!element() || selectedElementIncludesLastSelectedDevice() || !canAddDataset() || settingsLoading()"/>
        }
    }
</div>

<p-menu #nodesDevicesMenu popup appendTo="body" [model]="devicesMenuNodes()">
    <ng-template #submenuheader let-item>
        <ng-container *ngTemplateOutlet="submenuHeader; context: {$implicit: item}"/>
    </ng-template>
</p-menu>
<p-menu #nodesMetricsMenu popup appendTo="body" [model]="metricsMenuNodes()">
    <ng-template #submenuheader let-item>
        <ng-container *ngTemplateOutlet="submenuHeader; context: {$implicit: item}"/>
    </ng-template>
</p-menu>

<p-menu #changeNodesDevicesMenu popup appendTo="body" [model]="changeDevicesMenuNodes()">
    <ng-template #start>
        <p-button label="Удалить узел"
                  class="node-remove"
                  severity="secondary"
                  size="small"
                  outlined
                  (click)="changeNodesDevicesMenu.toggle($event); removeDeviceNode()"
                  [style]="{display: 'block', width: 'calc(100% - .5rem)', margin: '.25rem .25rem 0 .25rem'}"/>
    </ng-template>
    <ng-template #submenuheader let-item>
        <ng-container *ngTemplateOutlet="submenuHeader; context: {$implicit: item}"/>
    </ng-template>
</p-menu>
<p-menu #changeNodesMetricsMenu popup appendTo="body" [model]="changeMetricsMenuNodes()">
    <ng-template #start>
        <p-button label="Удалить узел"
                  class="node-remove"
                  severity="secondary"
                  size="small"
                  outlined
                  (click)="changeNodesMetricsMenu.toggle($event); removeDeviceMetricNode()"
                  [style]="{display: 'block', width: 'calc(100% - .5rem)', margin: '.25rem .25rem 0 .25rem'}"/>
    </ng-template>
    <ng-template #submenuheader let-item>
        <ng-container *ngTemplateOutlet="submenuHeader; context: {$implicit: item}"/>
    </ng-template>
</p-menu>

<p-menu #changeMetricsMenu popup appendTo="body" [model]="changeMetricsMenuItems()">
    <ng-template #start>
        <p-button label="Удалить узел"
                  class="node-remove"
                  severity="secondary"
                  size="small"
                  outlined
                  (click)="changeMetricsMenu.toggle($event); removeMetricNode()"
                  [style]="{display: 'block', width: 'calc(100% - .5rem)', margin: '.25rem .25rem 0 .25rem'}"/>
    </ng-template>
    <ng-template #submenuheader let-item>
        <ng-container *ngTemplateOutlet="submenuHeader; context: {$implicit: item}"/>
    </ng-template>
</p-menu>

<ng-template #submenuHeader let-item>
    <div class="sub-menu-header">
        <span class="line"></span>
        <span class="label">{{ item.label }}</span>
        <span class="line"></span>
    </div>
</ng-template>
